import { Form, Input } from 'antd5';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  ExternalServiceRequestChooser,
  getTurbinesFromTasks,
} from 'components/choosers/ExternalServiceRequestChooser';
import { Button, Modal, ModalActionButtons } from 'components/ui';

interface IWorkOrderNameEditorProps {
  workOrder: any;
  onSave: (name: string) => void;
}
export const WorkOrderNameEditor: React.FunctionComponent<IWorkOrderNameEditorProps> = ({
  workOrder,
  onSave,
}) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  const turbineList = getTurbinesFromTasks(workOrder.tasks);
  const [visible, setVisible] = useState(true);
  const [name, setName] = useState(workOrder.name);
  const assetIdForMaximo = turbineList.length === 1 ? turbineList[0] : '';
  function handleClose() {
    setVisible(false);
  }

  const handleExternalServiceRequestChange = (value: string, option: string) => {
    setName(value + ' ' + option);
  };
  const handleSave = () => {
    setVisible(false);
    onSave(name);
  };
  return (
    <Modal
      title={t('workOrder.editNameTitle', 'Edit Work Order Name')}
      open={visible}
      footer={null}
      onCancel={handleClose}
    >
      <Form layout="vertical" form={form}>
        <Form.Item
          label={t('workOrder.maximoServiceRequestNumber', 'Maximo Service Request Number')}
          name="serviceRequestNumber"
        >
          <ExternalServiceRequestChooser
            assetId={assetIdForMaximo}
            disableForMultipleTurbines={turbineList.length > 1 ? true : false}
            onChange={handleExternalServiceRequestChange}
          />
        </Form.Item>
        <Form.Item
          label={t('forms.name', 'Name')}
          rules={[
            {
              required: true,
              message: t(
                'forms.validation.workOrderNameRequired',
                'Please give this work order a name.'
              ),
            },
          ]}
        >
          <Input
            data-testid="name-input"
            placeholder={t('forms.name', 'Name')}
            value={name}
            style={{ marginRight: '2rem' }}
            onChange={e => setName(e.target.value)}
          />
        </Form.Item>
        <ModalActionButtons>
          <Button type="primary" onClick={handleSave}>
            {t('common.edit', 'Edit')}
          </Button>
          <Button onClick={handleClose}>{t('common.cancel', 'Cancel')}</Button>
        </ModalActionButtons>
      </Form>
    </Modal>
  );
};
